import React, {Fragment, useEffect, useRef, useState} from "react";
import {Link, NavLink, useLocation,useParams} from "react-router-dom";
import '../../assets/css/home.css';
import axios from "axios";
import clientconfigwebapp, {
    Agent_by_user_get_appbk,
    check_login_appbk, empty_bk,
    FormatNumberByhkh,
    get_first_last_name_local, modal_select_agent_show_hide,
    scrollTo_uphk, Token_get_appbk
} from "../../clientconfigwebapp";
import {toast, ToastContainer} from "react-toastify";
import Grid from '@mui/material/Grid';

import Master_Front from "../../pages/Master_Front";
import Aside from "../../components/Aside";
import Card_view from "../../components/Cart_box/Card_view";
import Post_product_Gride from "../../components/Grid_box/Post_product_Gride";
import Slider_show_home from "../../components/Sliders_box/Slider_show_home";

import Sticky from 'react-stickynode';


import {Skeleton} from "@mui/material";
import ProductCard from "../../components/Card_boxs/ProductCard";
import Pagination_bk from "../../components/Pagination_bk";
import ArvanPlayerComponent from "../../components/Player/ArvanPlayerComponent";

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Home = (props) => {
    const location_get_urlbk = useLocation();

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    /*  end profile */


    let query = useQuery();
  const {id_cat_getuser} = useParams();


    const is_device_mobile = window.matchMedia("(max-width: 700px)");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);


    const [data_slider_list, set_data_slider_list] = useState([]);
    const [data_category_box, set_data_category_box] = useState([]);
    const [list_post_Data, set_list_post_Data] = useState([]);
    const [data_paged_info, set_data_paged_info] = useState([]);

    ///const [id_cat_getuser, set_id_cat_getuser] = useState("");


    const [activeSection, setActiveSection] = useState('sec-1');

    const [scrollY, setScrollY] = useState(0);


    /* paged start */
    let page_number=query.get("page");
    const page = useRef();
    function paginationStyle (e) {
        const list = page.current.childNodes;
        for (let index = 0; index < list.length; index++) {
            const element = list[index];
            element.className = "";
        }
        e.target.className = "active-page"
    }
    /* paged end */
    function logit() {
        setScrollY(window.pageYOffset);
    }



    useEffect(() => {
       /// scrollTo_uphk();

// if(!empty_bk(id_cat_getuser)){     Load_api_page_cat();  }else{      Load_api_page();   }

        Load_api_page();


    }, [location_get_urlbk]);



    useEffect(() => {
        window.addEventListener('resize', setWindowDimensions);
        return () => {
            window.removeEventListener('resize', setWindowDimensions)
        }
    }, []);


    // const handleClick = (id_Get) => {
    //     ////alert(id_Get);
    //     ///set_id_cat_getuser('328455');
    //   ////  set_id_cat_getuser(id_Get);
    //
    //     Load_api_page_cat();
    //
    // }

    // const simplifiedFunction (value) {
    //     console.log(value)
    // }


    const setWindowDimensions = () => {
        setWindowWidth(window.innerWidth)
    }


    const handleLinkClick = (section) => {
        setActiveSection(section);
        scrollToSection(section);
    };

    const scrollToSection = (section) => {
        const element = document.getElementById(section);
    };





    const Load_api_page= () => {

        var config = null;

        if(check_login_appbk()==true){
            config = {
                headers: { Authorization: `Bearer ${Token_get_appbk()}` }
            };
        }


        var post_get_user="";
      if(!empty_bk(id_cat_getuser)){ post_get_user=String(id_cat_getuser);  }


       /////console.log(post_get_user,"id_cat_getuser")
        ///console.log(page_number,"page_number");
        const data_form = {post_id:String(post_get_user),page_number:page_number};

        axios.post(`${clientconfigwebapp.siteurl}api/v1/home-get-data/` ,data_form,config)
            .then((res) => {
                console.log(res.data.data_paged_info,"data_paged_infodata_paged_info");
              /////  console.log(res.data)
                if(String(res.data).length > 0) {


                    if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                    if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                    if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }

                    if(String(res.data.data_slider_list).length > 0) {  set_data_slider_list(res.data.data_slider_list); }
                    if(String(res.data.data_category_box).length > 0) {  set_data_category_box(res.data.data_category_box); }

                    set_list_post_Data(res.data.data_list_posts);
                    set_data_paged_info(res.data.data_paged_info);




                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }

            }).catch((err) =>{
            /// Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 5156', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });





    }


    return (
      <Fragment>

<Master_Front   wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} >


    <ToastContainer />



    {
        data_slider_list.length==0 ?  (
            <Fragment></Fragment>


        ) : (

            <Slider_show_home data_slider_list={data_slider_list}    />


        ) }






    <section className='w-100 flexRowBetStart home-section-container home-products-show'>

        {/*handleClickFromParent={(child) => this.child = child}*/}

        <div className={"aside-container-main side-bar-right-homebk"}>
            <Sticky top="#sidebarrightbk" bottomBoundary="#content">
            <Aside  costume_class={"side_bar_pc_home"} data_category_box={data_category_box} />
                {/*<Aside  handleClick={ ()=> handleClick()  }  costume_class={"side_bar_pc_home"} data_category_box={data_category_box} />*/}
            </Sticky>
        </div>


        <section id={"content"} className='flexColStartStart home-container-contents home-content-main-bk'>




            <section className='home-items-container'>



            {
                list_post_Data.length==0 ?  (
                    <React.Fragment>

                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />

                    </React.Fragment>


                ) : (

                    list_post_Data.map((item_post,index) => {

                        return (
                            <Fragment>
                                <ProductCard  link_to={"course/" + item_post.id_post} data_full_curent_item={item_post}    />
                            </Fragment>

                        );

                    })


                ) }

            </section>





            {
                !empty_bk(id_cat_getuser) ?  (
                    <Fragment>
                        <div className={"paginationbox"}>
                            <Pagination_bk link_page_curent={'course-category/' + String(id_cat_getuser) + '/'} class_nav_pagination_bk={'pagination_bk'} class_item_pagination_bk={'item_pagination_bk'} limit_page={data_paged_info.limit_page_bk}  count_pages={data_paged_info.pages_numb_bk} page_active={data_paged_info.page_curent_numb_bk}   />
                        </div>
                    </Fragment>


                ) : (

                   <Fragment>
                       <div className={"paginationbox"}>
                           <Pagination_bk link_page_curent={''} class_nav_pagination_bk={'pagination_bk'} class_item_pagination_bk={'item_pagination_bk'} limit_page={data_paged_info.limit_page_bk}  count_pages={data_paged_info.pages_numb_bk} page_active={data_paged_info.page_curent_numb_bk}   />
                       </div>
                   </Fragment>

                ) }







        </section>







    </section>




</Master_Front>

      </Fragment>
    );
  }
  
  export default Home;